export function validateRequired(e, name = false, value = false) {
    const { validate } = this.state

    // Is event passed in?
    if (e !== false) {
        name = e.target.name;
        value = e.target.value;
    }

    if (value !== '') {
        validate[name] = 'has-success'
    } else {
        validate[name] = 'has-danger'
    }

    this.setState({ validate })
}

export function validateRequiredCheckbox(e, name = false, value = false) {
    const { validate } = this.state

    // Is event passed in?
    if (e !== false) {
        name = e.target.name;
        value = e.target.value;
    }

    if (value !== 'true') {
        validate[name] = 'has-success'
    } else {
        validate[name] = 'has-danger'
    }

    this.setState({ validate })
}

export function validateEmail(e) {
    const { validate } = this.state;

    // Must be valid email
    const emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(e.target.value)) {
        validate.email = 'has-success'
    } else {
        validate[e.target.name] = 'has-danger'
    }

    this.setState({ validate })
}

export function validatePhone(e, name, required = false) {
    const { validate } = this.state;

    // Must be valid email
    const phoneRex = /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?\#(\d{4}|\d{3}))?$/;

    const number = e.target.value.trim()

    if (required) {
        if (phoneRex.test(number)) {
            validate[name] = 'has-success'
        } else {
            validate[name] = 'has-danger'
        }
    } else {
        if (number === ''){
            validate[name] = ''
        } else if (phoneRex.test(number)) {
            validate[name] = 'has-success'
        } else {
            validate[name] = 'has-danger'
        }
    }

    this.setState({ validate })
}

export function validateAmount(e, name, err, max, emptyErrMsg) {
    const { validate } = this.state
    const value = e.target.value

    if (value === '') {
        validate[name] = 'has-danger'
        validate[err] = emptyErrMsg
    } else if (isNaN(value)) {
        validate[name] = 'has-danger'
        validate[err] = 'Only numbers are allowed'
    } else if (value > max) {
        validate[name] = 'has-danger'
        validate[err] = 'Value must be less then ' + max
    } else if (value <= max) {
        validate[name] = 'has-success'
        validate[err] = emptyErrMsg
    }

    this.setState({ validate })
}

export function validateFile(e, name, err) {
    const { validate } = this.state;

    if (e.target.files[0]) {

        if (/\.(jpe?g|png|gif|pdf)$/i.test(e.target.files[0].name) === false) { 
            validate[name+'ErrMsg'] = 'has-danger';
            validate[name+'ErrMsg'] = 'This file type is not allowed';
        } else {
            validate[name + 'ErrMsg'] = false;
            
        }

    }

    this.setState({ validate })

}